import http from "../../http";
export default {
  list: data => {
    return http.get("cmsservice/cms_poster/page", data);
  },
  add: data => {
    return http.post("cmsservice/cms_poster/add", data);
  },
  update: data => {
    return http.post("cmsservice/cms_poster/update", data);
  },
  delete(params) {
    return http.post("cmsservice/cms_poster/delete", params);
  },
  xfs: {
    sid: data => {
      return http.get("content-service/xinfushe/sid", data);
    },
    sso: data => {
      return http.post("content-service/xinfushe/sso", data);
    }
  },
  template: {
    list: data => {
      return http.get("cmsservice/cms_postertemplate/page", data);
    },
    add: data => {
      return http.post("cmsservice/cms_postertemplate/add", data);
    },
    update: data => {
      return http.post("cmsservice/cms_postertemplate/update", data);
    },
    del: data => {
      return http.post("cmsservice/cms_postertemplate/delete", data);
    }
  },
  statistice: {
    list: data => {
      return http.post("marketcenter/share/sharecode/list", data);
    },
    details: data => {
      return http.post("marketcenter/share/code/detail/list", data);
    },
    num: data => {
      return http.post("marketcenter/share/sharecode/stat/indicators", data);
    }
  },
  type: {
    tree(params) {
      return http.get("cmsservice/posterSort/tree", params);
    },
    add(params) {
      return http.post("cmsservice/posterSort/add", params);
    },
    update(params) {
      return http.put("cmsservice/posterSort/update", params);
    },
    delete(id) {
      return http.delete("cmsservice/posterSort/del/" + id, {});
    }
  }
};
